import routerOptions0 from "/home/runner/work/moduleplus-moduleplus.ch/moduleplus-moduleplus.ch/nuxt-app/app/router.options.ts";
import routerOptions1 from "/home/runner/work/moduleplus-moduleplus.ch/moduleplus-moduleplus.ch/nuxt-app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}